import { useEffect } from 'react';
import { useSiteConfig } from '../hooks/useSiteConfig';

export default function DocumentHead() {
  const { site } = useSiteConfig();

  useEffect(() => {
    if (site.title) {
      document.title = site.title;
    }
    if (site.description) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) {
        meta.setAttribute('content', site.description);
      }
    }
  }, [site.title, site.description]);

  return null;
}
